module.exports = __webpack_public_path__ + "static/media/slide-brick.19c3eda8.jpg";